import { render, staticRenderFns } from "./Zadak.vue?vue&type=template&id=41da1bb6&scoped=true&"
import script from "./Zadak.vue?vue&type=script&lang=js&"
export * from "./Zadak.vue?vue&type=script&lang=js&"
import style0 from "./Zadak.vue?vue&type=style&index=0&id=41da1bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41da1bb6",
  null
  
)

export default component.exports